import React from "react";
import QuoteRequestModalHomeLibrary from "./quote-request-modal-home-library";

export default class KeygroupsImagesState extends React.Component  
{
    constructor(props)    
    {
        super(props);

        if(this.props.code !== undefined)
        {
            this.code = this.props.code;
            switch(this.code)
            {
                case 'pool-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Swimming Pool Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Above Ground Pool Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Above Ground Pool Removal',
                                        path: '/images/keygroups/Scroll-Image---Above-Ground-Pool-Removal.webp'
                                    }
                                },
                                {
                                    title: 'Inground Pool Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Inground Pool Removal',
                                        path: '/images/keygroups/Scroll-Image---Inground-Pool-Removal.webp'
                                    }
                                }   
                            ]
                        }
                    ]
                    break

                case 'oil-tank-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Tank Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Oil Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Oil Tank Removal',
                                        path: '/images/keygroups/Scroll-Image---Oil-Tank-Removal.webp'
                                    }
                                },
                                {
                                    title: 'Propane Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Propane Tank Removal',
                                        path: '/images/keygroups/Scroll-Image---Propane-Tank-Removal.webp'
                                    }
                                },
                                {
                                    title: 'Septic Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Septic Tank Removal',
                                        path: '/images/keygroups/Scroll-Image---Septic-Tank-Removal.webp'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'barn-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Barn Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Barn Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Barn Demolition',
                                        path: '/images/keygroups/Scroll-Image---Barn-Demolition.webp'
                                    }
                                }  
                            ]
                        }
                    ]
                    break
                
                case 'chimney-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Chimney Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Chimney Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Chimney Removal',
                                        path: '/images/keygroups/Scroll-Image---Chimney-Removal.webp'
                                    }
                                }  
                            ]
                        }
                    ]
                    break

                case 'commercial-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Commercial Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Commercial Building Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Building Demolition',
                                        path: '/images/keygroups/Scroll-Image---Commercial-Demolition.webp'
                                    }
                                }  
                            ]
                        }
                    ]
                    break

                case 'concrete-removal':                    
                    this.services =
                    [
                        {
                            title: 'Popular Concrete Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Brick Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Brick Removal',
                                        path: '/images/keygroups/Scroll-Image---Brick-Removal.webp'
                                    }
                                },
                                {
                                    title: 'Asphalt Driveway Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Asphalt Driveway Removal',
                                        path: '/images/keygroups/Scroll-Image---Asphalt-Driveway-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Asphalt Parking Lot Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Asphalt Parking Lot Removal',
                                        path: '/images/keygroups/Scroll-Image---Asphalt-Parking-Lot-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Concrete Driveway Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Driveway Removal',
                                        path: '/images/keygroups/Scroll-Image---Concrete-Driveway-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Concrete Foundation Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Foundation Removal',
                                        path: '/images/keygroups/Scroll-Image---Concrete-Foundation-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Concrete Parking Lot Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Parking Lot Removal',
                                        path: '/images/keygroups/Scroll-Image---Concrete-Parking-Lot-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Concrete Patio Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Patio Removal',
                                        path: '/images/keygroups/Scroll-Image---Concrete-Patio-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Concrete Sidewalk Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Sidewalk Removal',
                                        path: '/images/keygroups/Scroll-Image---Concrete-Sidewalk-Removal.webp'
                                    }
                                },                                
                                {
                                    title: 'Other Asphalt/Concrete Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Other Asphalt/Concrete Removal',
                                        path: '/images/keygroups/Scroll-Image---Other-Concrete-Asphalt-Removal.webp'
                                    }
                                }                                                                    
                            ]
                        }
                    ]
                    break

                case 'residential-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Residential Demolitions Projects',
                            cards:
                            [
                                {
                                    title: 'Deck Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Deck Removal',
                                        path: '/images/keygroups/Scroll-Image---Deck-Removal.webp'
                                    }
                                },
                                {
                                    title: 'Fence Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Fence Removal',
                                        path: '/images/keygroups/fence-_emoval.webp'
                                    }
                                },
                                {
                                    title: 'Shed Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Shed Demolition',
                                        path: '/images/keygroups/Scroll-Image---Shed-Demolition.webp'
                                    }
                                }   
                            ]
                        }
                    ]
                    break

                case 'house-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Commercial Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Garage Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Garage Demolition',
                                        path: '/images/keygroups/Scroll-Image---Garage-Demolition.webp'
                                    }
                                },
                                {
                                    title: 'House Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'House Demolition',
                                        path: '/images/keygroups/Scroll-Image---House-Demolition.webp'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'interior-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Interior Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Commercial Interior Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Interior Demolition',
                                        path: '/images/keygroups/Scroll-Image---Commercial-Interior-Demolition.webp'
                                    }
                                },
                                {
                                    title: 'Residential Interior Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Residential Interior Demolition',
                                        path: '/images/keygroups/Scroll-Image---Residential-Interior-Demolition.webp'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'mobile-home-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Mobile Home Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Mobile Home Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Mobile Home Demolition',
                                        path: '/images/keygroups/Scroll-Image---Mobile-Home-Demolition.webp'
                                    }
                                }    
                            ]
                        }
                    ]
                    break
            }         
        }
    }   
    
    render()
    {
        return (
            <div className={"container-fluid keygroups-images alone"}>      
                <div className="container">          
                    <div className="row">
                    {
                            this.services && this.services.map(service =>
                            {                                                 
                                return(
                                    <div className="col-12">
                                        <h3>{service.title}</h3>
                                            <div className="cards">
                                            {
                                                service.cards.map((card, index) =>
                                                {
                                                    return(
                                                    <QuoteRequestModalHomeLibrary
                                                        service={card}
                                                        startVisible={false}    
                                                    />
                                                    ) 
                                                })
                                            } 
                                        </div>                                   
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
};